
<template>
  <v-app id="onNttp">
    <v-main>
    <v-container fluid>  
    <v-card>
      
      Nr: {{nttp.nttp_nr}}  

      <span v-for="(nttptaalRecord,i) in nttp.nttptaal" :key="i">
       <br>
       {{nttptaalRecord.taal_code}}  <v-btn class="primary ma-2" small @click="saveNttptaal(nttptaalRecord)">Save</v-btn><br>
       <v-textarea v-model="nttptaalRecord.nttptaal_oms" :value=nttptaalRecord.nttptaal_oms rows="1" label="Translation" spellcheck="false"></v-textarea>
       <br>
      </span>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  props: ['nttp_encrid'],
  data() {
    return {
      nttp: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/nttp/getNttp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getNttp"
          },
          getNttp: {
             nttp_encrid: this.nttp_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.nttp = res.data.getNttp;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  methods: {
    saveNttptaal(nttptaal) { 
      this.$axios
        .post("ares/json/ares/syst/ref/nttp/saveNttptaal.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveNttptaal"
          },
          saveNttptaal: {
            nttptaal: nttptaal
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveNttptaal.text,
              color: res.data.saveNttptaal.color
            });
          }
        })
    }
  }  

};

</script> 
